// Module
var code = " <mat-icon svgIcon=\"gh:close\" *ngIf=\"display &amp;&amp; !disabled\" class=\"s16 gh-autocomplete-clear-icon\" matTooltip=\"{{'lbl_clear' | translate}}\"></mat-icon> ";
// Exports
module.exports = code;